import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ErrorAnim } from '../../molecules/Animations';

import { IMplModalProps, MplModal } from './MplModal';

export const MplErrorModal: FC<IMplModalProps> = ({ ...mplModalProps }) => {
	const { t } = useTranslation('errors');

	return (
		<MplModal
			icon={<ErrorAnim loop />}
			title={t('header.internal')}
			content={t('text.internal_description')}
			{...mplModalProps}
		/>
	);
};
